"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisteredForm = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_i18next_1 = require("react-i18next");
var loginSlice_1 = require("../../../features/login/loginSlice");
var auth = __importStar(require("../../../helpers/auth"));
var Copyright_1 = __importDefault(require("../../../components/Copyright"));
var AppSlogan_1 = __importDefault(require("../AppSlogan"));
var Button_1 = __importDefault(require("../../../components/Button"));
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var RegisteredForm = function () {
    var dispatch = react_redux_1.useDispatch();
    var t = react_i18next_1.useTranslation('common').t;
    react_1.useEffect(function () {
        auth.removeUnverifiedEmail();
    }, []);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.page },
        react_1.default.createElement(AppSlogan_1.default, { title: t('APP_SLOGAN.TITLE'), text: t('APP_SLOGAN.TEXT'), backgroundType: "second", backgroundColor: "ternary" }),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.form },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.content_body },
                    react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('YOUR_EMAIL_SUCCESSFULLY_VERIFIED')),
                    react_1.default.createElement("p", { className: styles_module_scss_1.default.sub_title }, t('THANK_YOU_FOR_USING_BANALI')),
                    react_1.default.createElement(Button_1.default, { type: "button", variant: "text", onClick: function () {
                            dispatch(loginSlice_1.openLoginFormModal({
                                redirectAfterLogin: true,
                            }));
                        } }, t('FORM_ITEMS.SIGN_IN'))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.footer },
                    react_1.default.createElement(Copyright_1.default, null))))));
};
exports.RegisteredForm = RegisteredForm;
exports.default = exports.RegisteredForm;
